import { Box, styled } from "@mui/material";
import { ReactElement } from "react";

import {
  DEFAULT_AUTO_MMS_BREAKPOINT,
  EncodingStats,
} from "@stw/sms-text-encoding";

import { useTenant } from "~frontend/providers/LoggedInUserProvider";
import { palette } from "~frontend/theme";

const SegmentEstimateContainer = styled("div")({
  padding: "0 4px",
  backgroundColor: palette.lightOrange,
  fontSize: "12px",
  fontWeight: 400,
});

export const SegmentEstimate = ({
  encodingStats,
}: {
  encodingStats: EncodingStats | null;
}): ReactElement => {
  if (!encodingStats || encodingStats.sendAsMessageType === "MMS") {
    return <span />;
  }

  return (
    <SegmentEstimateContainer>
      <strong>{encodingStats.segments}</strong> Estimated Segment
      {encodingStats.segments > 1 ? "s" : ""}
    </SegmentEstimateContainer>
  );
};

export const SegmentEstimateDetail = ({
  encodingStats,
  hasAttachments,
}: {
  encodingStats: EncodingStats | null;
  hasAttachments: boolean;
}): ReactElement => {
  const tenant = useTenant()!;

  if (!encodingStats) {
    return <span />;
  }

  return (
    <Box>
      <span style={{ fontWeight: 500 }}>~{encodingStats.charCount}</span> Total
      Characters /{" "}
      {encodingStats.charCount > encodingStats.maxChars ? (
        <strong style={{ color: palette.red }}>
          Message exceeds maximum of {encodingStats.maxChars.toLocaleString()}{" "}
          characters
        </strong>
      ) : (
        <>
          <span style={{ fontWeight: 500 }}>
            {encodingStats.charsLeftInSegment}
          </span>{" "}
          Characters Left in{" "}
          {encodingStats.sendAsMessageType === "SMS" ? (
            "Segment"
          ) : hasAttachments ? (
            "Message"
          ) : (
            <>
              Message (
              <strong>
                &ge; {tenant.autoMMSBreakpoint || DEFAULT_AUTO_MMS_BREAKPOINT}{" "}
                segments billed as MMS
              </strong>
              )
            </>
          )}
        </>
      )}
    </Box>
  );
};
